import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "goods_order_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "下单人信息", -1);

const _hoisted_7 = {
  class: "base_details_content_second"
};
const _hoisted_8 = {
  key: 0,
  class: "base_details_title"
};
const _hoisted_9 = {
  key: 1,
  class: "base_details_content_second"
};
const _hoisted_10 = {
  key: 2,
  class: "base_details_title"
};
const _hoisted_11 = {
  key: 3,
  class: "base_details_content_second"
};
const _hoisted_12 = {
  key: 4,
  class: "base_details_title"
};
const _hoisted_13 = {
  key: 5,
  class: "base_details_content_second"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "商品信息", -1);

const _hoisted_15 = {
  class: "base_details_content_second"
};
const _hoisted_16 = {
  class: "image-container"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 0,
  class: "text-overlay"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠信息", -1);

const _hoisted_20 = {
  class: "base_details_content_second"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  key: 2
};

const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "-", -1);

const _hoisted_25 = {
  key: 6,
  class: "base_details_title"
};
const _hoisted_26 = {
  key: 7,
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref } from "vue";
import { $msg, $box } from "@ui/msg";
import useRoute from "@util/router";
import OrderShipments from "@com/order/OrderShipments.vue";
import CancelOrder from "@com/order/CancelOrder.vue";
import CancelAfterSale from "@com/order/CancelAfterSale.vue";
import ConfirmAfterSale from "@com/order/ConfirmAfterSale.vue";
import $ from "@util/base";
import api from "@api/order";
import afterApi from "@api/afterSaleOrder";
export default {
  __name: 'GoodsOrderDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const typeKey = urlQuery.type;
    var readOnly = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
      }
    });
    const data = ref({
      orderItem: {},
      // 订单信息
      expressList: [],
      // 发货信息列表(物流信息)
      addressItem: {},
      // 收货人信息
      placeOrderItem: {},
      // 下单人信息
      skuList: [],
      // 商品列表
      promotionList: [],
      // 优惠列表
      cancelReason: null,
      // 取消原因
      afterSaleItem: {},
      // 售后信息
      payList: [] // 支付信息列表

    }); //指定行颜色

    function tableRowClassName({
      row,
      rowIndex
    }) {
      console.log(JSON.stringify(row));

      if ($.isNotEmpty(row.status) && row.status != '已取消') {
        return 'choose-row';
      } else {
        return '';
      }
    }

    const expenseAftersale = ref(null);
    const refundMoney = ref(null);
    const depositMoney = ref(null);
    getData();

    function getData() {
      api.detail('goods', urlQuery.code, urlQuery.afterSaleCode, val => {
        // 1019001 快递配送、1019002 用户自提
        switch (val.orderItem.deliveryType) {
          case '1019001':
            val.orderItem.deliveryTypeVal = '快递配送';
            break;

          case '1019002':
            val.orderItem.deliveryTypeVal = '用户自提';
            break;

          default:
            val.orderItem.deliveryTypeVal = '-';
        }

        if ($.isNotEmpty(val.afterSaleItems)) {
          val.afterSaleItem = val.afterSaleItems[0];
          refundMoney.value = val.afterSaleItem.refundMoney;
          depositMoney.value = val.afterSaleItem.depositMoney;
        }

        expenseAftersale.value = val.orderItem.expenseAftersale;
        data.value = val;
        deliveryType.value = val.orderItem.deliveryType;
        getConfig(val.orderItem.orderStatus);
      });
    }

    const deliveryType = ref("");
    const statusTitle = ref("已完成"); // 1018001 未付款、1018002 待发货、1018003 已取消、1018004 待取货、1018005 待收货、1018006 已完成

    function getConfig(status) {
      switch (status) {
        case "1018001":
          statusTitle.value = "未付款";
          break;

        case "1018002":
          statusTitle.value = "待发货";
          break;

        case "1018003":
          statusTitle.value = "已取消";
          break;

        case "1018004":
          statusTitle.value = "待取货";
          break;

        case "1018005":
          statusTitle.value = "待收货";
          break;

        case "1018006":
          statusTitle.value = "已完成";
          break;
      }
    } // function pick() {
    //   $box.input("领取", "提货码", null, () => {
    //     $msg.succ("领取成功");
    //   });
    // }


    const shipmentsRef = ref("");

    function shipments() {
      shipmentsRef.value.show();
    }

    function getShipments(data) {
      api.shipment('goods', {
        orderCode: urlQuery.code,
        expressDetail: data.express // expressName: data.company,
        // expressNo: data.number

      }, () => {
        $msg.succ("发货成功");
        getData();
      });
    }

    const cancelOrderRef = ref("");

    function cancelOrder() {
      cancelOrderRef.value.show();
    }

    function confirmAfterSale() {
      confirmAfterSaleRef.value.show();
    }

    function confirmAfterSaleSubmit(money, deposit) {
      afterApi.confirm(data.value.afterSaleItem.afterSaleCode, money, deposit, () => {
        $msg.succ("退款成功");
        getData();
      });
    }

    const cancelAfterSaleRef = ref(null);
    const confirmAfterSaleRef = ref(null);

    function cancelAfterSale() {
      cancelAfterSaleRef.value.show();
    }

    function getCancelAfterSale(res) {
      afterApi.cancel({
        afterSaleCode: data.value.afterSaleItem.afterSaleCode,
        remark: res.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    function confirmTakeOver() {
      $box.alert("确认收货", `<div>确定已收到退货商品？</div><div>${data.value.afterSaleItem.expressName}：${data.value.afterSaleItem.expressNo}</div>`, () => {
        afterApi.takeOver(data.value.afterSaleItem.afterSaleCode, () => {
          $msg.succ("确定收货成功");
          getData();
        });
      });
    }

    function getCancelOrder(data) {
      api.cancel({
        type: 'goods',
        code: urlQuery.code,
        // amount: data.amount,
        remark: data.reason
      }, () => {
        $msg.succ("取消成功");
        getData();
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      const _component_el_descriptions = _resolveComponent("el-descriptions");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_unref(typeKey) === 'after' ? (_openBlock(), _createBlock(BackTitleView, {
          key: 0,
          title: `售后详情-${data.value.afterSaleItem.afterSaleStatusName}`
        }, null, 8, ["title"])) : (_openBlock(), _createBlock(BackTitleView, {
          key: 1,
          title: `订单详情-${data.value.orderItem.orderStatusStr}`
        }, null, 8, ["title"])), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "订单编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.orderCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "发货方式："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.deliveryTypeVal), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "归属基地："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.shopName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "下单时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.createTime), 1)]),
              _: 1
            }), data.value.orderItem.payTime ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "付款时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.payTime), 1)]),
              _: 1
            })) : _createCommentVNode("", true), data.value.orderItem.deliveryTime ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 1,
              label: "发货时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.deliveryTime), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "邮费："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.orderItem.postageMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "活动优惠："
            }, {
              default: _withCtx(() => [_createTextVNode("-¥" + _toDisplayString(data.value.orderItem.discountMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "储值支付："
            }, {
              default: _withCtx(() => [_createTextVNode("-¥" + _toDisplayString(data.value.orderItem.depositMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "积分兑换："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.integral), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "实付金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.orderItem.dueMoney), 1)]),
              _: 1
            }), data.value.orderItem.agentMemberName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 2,
              label: "分销员："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.orderItem.agentMemberName), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "下单人："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.placeOrderItem.placeOrderName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "联系电话："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.placeOrderItem.phoneNumber), 1)]),
              _: 1
            })]),
            _: 1
          })]), deliveryType.value == '1019001' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "收货人信息")) : _createCommentVNode("", true), deliveryType.value == '1019001' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "收货人："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.addressItem.recipientName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "联系电话："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.addressItem.phoneNumber), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "收货地址："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.addressItem.address), 1)]),
              _: 1
            })]),
            _: 1
          })])) : _createCommentVNode("", true), statusTitle.value == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_10, "取消原因")) : _createCommentVNode("", true), statusTitle.value == '已取消' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(data.value.cancelReason), 1)) : _createCommentVNode("", true), data.value.expressList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, "发货信息")) : _createCommentVNode("", true), data.value.expressList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.expressList, (express, eIndex) => {
            return _openBlock(), _createElementBlock("span", {
              key: eIndex,
              style: {
                "white-space": "pre-line",
                "color": "#606266"
              }
            }, _toDisplayString(express.expressDetail), 1);
          }), 128))])) : _createCommentVNode("", true), _hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_table, {
            data: data.value.skuList,
            "row-class-name": tableRowClassName
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "商品图片",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
                src: scope.row.pic,
                style: {
                  width: '75px',
                  height: '75px'
                }
              }, null, 8, _hoisted_17), scope.row.status && scope.row.status != '已取消' ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(scope.row.status), 1)) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "商品名称",
              prop: "productName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "商品规格",
              prop: "attrName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "SKU编码",
              prop: "skuCode",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "价格",
              prop: "duePrice",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "商品数量",
              prop: "sellNum",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "小计",
              prop: "totalMoney",
              align: "center"
            })]),
            _: 1
          }, 8, ["data"])]), _hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_table, {
            data: data.value.promotionList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "优惠名称",
              prop: "promotionName",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "优惠金额",
              prop: "promotionMoney",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "优惠类型",
              align: "center"
            }, {
              default: _withCtx(scope => [scope.row.promotionType == '1020001' ? (_openBlock(), _createElementBlock("span", _hoisted_21, "优惠券")) : scope.row.promotionType == '1020002' ? (_openBlock(), _createElementBlock("span", _hoisted_22, "综合活动兑换")) : scope.row.promotionType == '1020003' ? (_openBlock(), _createElementBlock("span", _hoisted_23, "优惠活动")) : _createCommentVNode("", true), _hoisted_24]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]), _unref(typeKey) === 'after' ? (_openBlock(), _createElementBlock("div", _hoisted_25, "售后信息")) : _createCommentVNode("", true), _unref(typeKey) === 'after' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_el_descriptions, null, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "售后编码："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "订单业务类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.mainBusiTypeName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleTypeName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后状态："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.afterSaleStatusName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "售后原因类型："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.reasonType), 1)]),
              _: 1
            }), data.value.afterSaleItem.reasonDesc ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "售后原因详情："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.reasonDesc), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "会员编号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.memberCode), 1)]),
              _: 1
            }), data.value.afterSaleItem.cancelInfo ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 1,
              label: "售后取消原因："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.cancelInfo), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "退款金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.afterSaleItem.refundMoney), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "退还储值金额："
            }, {
              default: _withCtx(() => [_createTextVNode("¥" + _toDisplayString(data.value.afterSaleItem.depositMoney), 1)]),
              _: 1
            }), data.value.afterSaleItem.expressName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 2,
              label: "退回快递公司："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.expressName), 1)]),
              _: 1
            })) : _createCommentVNode("", true), data.value.afterSaleItem.expressNo ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 3,
              label: "退回快递单号："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.expressNo), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "创建时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.createTime), 1)]),
              _: 1
            }), data.value.afterSaleItem.updateTime ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 4,
              label: "更新时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.afterSaleItem.updateTime), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })])) : _createCommentVNode("", true)])])]),
          _: 1
        }), _unref(typeKey) === 'after' ? (_openBlock(), _createBlock(_component_el_footer, {
          key: 2
        }, {
          default: _withCtx(() => [data.value.afterSaleItem.afterSaleStatus === '1052001' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: confirmAfterSale,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(" 确认退款 ")]),
            _: 1
          })) : _createCommentVNode("", true), data.value.afterSaleItem.afterSaleStatus === '1052001' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelAfterSale,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(" 取消售后 ")]),
            _: 1
          })) : _createCommentVNode("", true), data.value.afterSaleItem.afterSaleStatus === '1052005' || data.value.afterSaleItem.afterSaleStatus === '1052006' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: confirmTakeOver,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("确认收货 ")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_footer, {
          key: 3
        }, {
          default: _withCtx(() => [!_unref(readOnly) && statusTitle.value == '待发货' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: shipments,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("发货")]),
            _: 1
          })) : _createCommentVNode("", true), !_unref(readOnly) && (statusTitle.value == '待发货' || statusTitle.value == '未付款') ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: cancelOrder
          }, {
            default: _withCtx(() => [_createTextVNode(" 取消订单 ")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(OrderShipments, {
        ref_key: "shipmentsRef",
        ref: shipmentsRef,
        onShipments: getShipments
      }, null, 512), _createVNode(CancelOrder, {
        ref_key: "cancelOrderRef",
        ref: cancelOrderRef,
        onCancelOrder: getCancelOrder
      }, null, 512), _createVNode(CancelAfterSale, {
        ref_key: "cancelAfterSaleRef",
        ref: cancelAfterSaleRef,
        onCancelAfterSale: getCancelAfterSale
      }, null, 512), _createVNode(ConfirmAfterSale, {
        ref_key: "confirmAfterSaleRef",
        ref: confirmAfterSaleRef,
        desc: expenseAftersale.value,
        money: refundMoney.value,
        deposit: depositMoney.value,
        onSubmit: confirmAfterSaleSubmit
      }, null, 8, ["desc", "money", "deposit"])]);
    };
  }

};